export const TIPOS_RESPUESTA = [
  { value: 1, label: 'Texto' },
  { value: 2, label: 'Selección única' },
  { value: 3, label: 'Tratamiento de datos' },
];

export const PREGUNTAS = 302
export const RESPUESTAS = 303